import { IterableElement } from 'type-fest'

import { Ticker } from './ticker'

export const BTC_TICKERS = [Ticker.BTC]

export type BtcTicker = IterableElement<typeof BTC_TICKERS>
